<template>
  <layout-default :hide-footer-mobile="true">

    <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
        integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
        crossorigin="anonymous"
    />
      <div class="pdv-container mt-5 mb-2" id="#ouletpage2" >
        <div class="custom-padding">
          <div class="div-alinear relative">
            <div class="item1">
              <div
                class="custom-acordeon outlet-student-accordion accordion-block accordion-block--student"
                :class="{ 'accordion-block--bordered': guardo_Estudiante }"
              >
                <div class="accordion" id="accordionInfo">
                  <div class="card">
                    <div class="card-body form-section">
                      <div
                        v-if="guardo_Estudiante"
                        class="accordion-header-outlet"
                        role="button"
                        tabindex="0"
                        @click="studentSectionExpanded = !studentSectionExpanded"
                        @keydown.enter.prevent="studentSectionExpanded = !studentSectionExpanded"
                        @keydown.space.prevent="studentSectionExpanded = !studentSectionExpanded"
                      >
                        <h2 class="form-section-title accordion-title">
                          Datos del estudiante
                        </h2>
                        <span class="accordion-arrow" :class="{ open: studentSectionExpanded }" aria-hidden="true">▼</span>
                      </div>
                      <h2 v-else class="form-section-title">
                        Datos del estudiante
                      </h2>
                      <div v-show="!guardo_Estudiante || studentSectionExpanded" class="accordion-body-outlet">
                        <form
                          id="alumnForm"
                          autocomplete="none"
                          @submit.prevent="ifFormValid($event, () => onSaveForm(1))"
                        >
                          <div class="row">
                            <div class="col-12">
                              <div class="pdv-form-group">
                                <div class="row custom-pdv-row">
                                  <div class="col-md-6 col-12">
                                    <div
                                      class="form-group"
                                      :class="{ error: errorMensAlumn && studentData.name == '' }"
                                    >
                                      <label for="inscriptionName">Nombre del estudiante</label>
                                      <input
                                          type="text"
                                          v-model="studentData.name"
                                          name="nombre"
                                          id="inscriptionName"
                                          onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                                          maxlength="30"
                                      />
                                      <p
                                          v-if="errorMensAlumn && studentData.name == ''"
                                          class="error-otp"
                                      >
                                        Debes agregar un Nombre
                                      </p>
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div
                                      class="form-group"
                                      :class="{ error: errorMensAlumn && studentData.name == '' }"
                                    >
                                      <label for="inscriptionFatherLastName">Primer apellido</label>
                                      <input
                                          type="text"
                                          v-model="studentData.fatherLastName"
                                          name="fatherLastName"
                                          id="inscriptionFatherLastName"
                                          onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                                          maxlength="30"
                                      />
                                      <p
                                          v-if="errorMensAlumn && studentData.name == ''"
                                          class="error-otp"
                                      >
                                        Debes agregar un el Apellido
                                      </p>
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div
                                      class="form-group"
                                      :class="{ error: errorMensAlumn && studentData.name == '' }"
                                    >
                                      <label for="inscriptionLastName">Segundo apellido</label>
                                      <input
                                          type="text"
                                          v-model="studentData.lastName"
                                          name="lastName"
                                          id="inscriptionLastName"
                                          onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                                          maxlength="30"
                                      />
                                      <p
                                          v-if="errorMensAlumn && studentData.name == ''"
                                          class="error-otp"
                                      >
                                        Debes agregar un el Apellido
                                      </p>
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div
                                      class="form-group"
                                      :class="{ error: errorMensAlumn && studentData.rut == '' }"
                                    >
                                      <label for="">RUT</label>
                                      <vue-mask
                                          mask="00.000.000-K"
                                          :raw="false"
                                          v-model="studentData.rut"
                                          :options="{
                                          reverse: true,
                                          translation: { K: { pattern: /[0-9kK]/ } }
                                        }"
                                          name="rut"
                                      ></vue-mask>
                                      <p
                                          v-if="errorMensAlumn && studentData.rut == ''"
                                          class="error-otp"
                                      >
                                        Debes agregar un Rut
                                      </p>
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="email">Email</label>
                                      <input
                                          type="email"
                                          v-model="studentData.email"
                                          name="email"
                                          maxlength="50"
                                          class="withErrorContainer"
                                          style="background-color: #ffffff; width: 100%;"
                                      />
                                      <div class="errorContainer"></div>
                                    </div>
                                  </div>                               
                                </div>
                                <div class="row">                            
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Fecha de nacimiento</label>      
                                      <vue-mask
                                          placeholder="dd/mm/aaaa"
                                          mask="DA/MO/YEXR"
                                          :raw="false"
                                          v-model="studentData.birthday"
                                          :options="dateMaskOptions"
                                          name="fecha"
                                      ></vue-mask>
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Celular</label>
                                      <the-mask
                                          mask="+569 ## ## ####"
                                          :masked="true"
                                          v-model="studentData.phone"
                                          type="tel"
                                          name="cel"
                                      ></the-mask>
                                    </div>
                                  </div>
                                </div>                              

                                <div class="row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group custom-select2-container">
                                      <label for="studentRegionSelect">Región del Colegio</label>
                                      <select
                                          id="studentRegionSelect"
                                          ref="studentRegionSelect"
                                          class="pdv-custom-select regionSelect"
                                          v-model="studentData.regionId"
                                          v-select2="studentData.regionId"
                                          :name="'region-' + timestamp"
                                          @change="onSelectStudentRegion(studentData.regionId)"
                                      >
                                        <option value="">Selecciona tu región</option>
                                        <option
                                            v-for="r in availableRegions"
                                            :key="r.id"
                                            :value="r.id"
                                        >
                                          {{ r.name }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>

                                  <div class="col-12 col-md-6">
                                    <div class="form-group custom-select2-container">
                                      <label for="studentCommuneSelect">Comuna del Colegio</label>
                                      <select
                                          id="studentCommuneSelect"
                                          ref="studentCommuneSelect"
                                          class="pdv-custom-select communeSelect"
                                          v-model="studentData.comuneId"
                                          v-select2="studentData.comuneId"
                                          :name="'comuna-' + timestamp"
                                          :disabled="!studentData.regionId"
                                          @change="onSelectCommune(studentData.comuneId)"
                                      >
                                        <option value="">Selecciona tu comuna</option>
                                        <option
                                            v-for="c in availableCommunes"
                                            :key="c.id"
                                            :value="c.id"
                                        >
                                          {{ c.name }}
                                        </option>
                                      </select>
                                      <div class="col-12">
                                        <div class="errorContainer"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group custom-select2-container">
                                      <label for="studentCollegeSelect">Colegio</label>
                                      <select
                                          id="studentCollegeSelect"
                                          ref="studentCollegeSelect"
                                          class="pdv-custom-select collegeSelected"
                                          v-model="studentData.establishment"
                                          v-select2="studentData.establishment"
                                          :name="'colegio-' + timestamp"
                                          :disabled="!studentData.comuneId"
                                          @change="onSelectColege(studentData.establishment)"
                                      >
                                        <option value="">Selecciona tu colegio</option>
                                        <option
                                            v-for="col in availableStudentsColleges"
                                            :key="col.id"
                                            :value="col.id"
                                        >
                                          {{ col.name }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-12">
                                    <div class="form-group custom-select2-container">
                                      <label for="graduationYear">Año de Egreso</label>
                                      <select
                                          id="graduationYear"
                                          class="withErrorContainer pdv-custom-select yearsSelected"
                                          name="añoGraduacion"
                                          v-model="studentData.graduationYear"
                                      >
                                        <option value="">Selecciona tu año de egreso</option>
                                        <option v-for="year in selectYears" :key="year" :value="year">
                                          {{ year }}
                                        </option>
                                      </select>
                                      <div class="col-12">
                                        <div class="errorContainer"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-actions form-actions--guardar">
                                  <button
                                      type="submit"
                                      class="btn-step2-continuar"
                                      :disabled="guardo_Estudiante == true"
                                  >
                                    Guardar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="guardo_Estudiante" class="custom-acordeon accordion-block accordion-block--apoderado mt-2">
                <div class="accordion" id="accordionInfo2">
                  <div class="card">
                    <div class="card-body form-section">
                      <h2 class="form-section-title">
                        Datos apoderado/a financiero/a
                      </h2>
                        <form
                          id="programInscription"
                          autocomplete="none"
                          @submit.prevent="ifFormValid($event, () => onSaveForm(0))"
                        >
                          <div class="row">
                            <div class="col-12">
                              <div class="pdv-form-group">
                                <div class="row custom-pdv-row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="inscriptionName">Nombres del apoderado/a</label>
                                      <input
                                          type="text"
                                          v-model="financingPartyData.name"
                                          name="nombre"
                                          id="inscriptionName"
                                          onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                                          maxlength="30"
                                      />
                                      <p
                                          v-if="errorMens && financingPartyData.name == ''"
                                          class="error-otp"
                                      >
                                        Debes agregar un Nombre
                                      </p>
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Primer apellido</label>
                                      <input
                                          type="text"
                                          v-model="financingPartyData.fatherLastName"
                                          name="apellidoPaterno"
                                          onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                                          maxlength="12"
                                      />
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Segundo apellido</label>
                                      <input
                                          type="text"
                                          v-model="financingPartyData.motherLastName"
                                          name="apellidoMaterno"
                                          onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                                          maxlength="12"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">RUT</label>
                                      <vue-mask
                                          mask="00.000.000-K"
                                          :raw="false"
                                          v-model="financingPartyData.rut"
                                          :options="{
                                          reverse: true,
                                          translation: { K: { pattern: /[0-9kK]/ } }
                                        }"
                                          name="rut"
                                      ></vue-mask>
                                      <p
                                          v-if="errorMens && financingPartyData.rut == ''"
                                          class="error-otp"
                                      >
                                        Debes agregar un Rut
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Celular</label>
                                      <the-mask
                                          mask="+569 ## ## ####"
                                          :masked="true"
                                          v-model="financingPartyData.phone"
                                          type="tel"
                                          name="cel"
                                          class="withErrorContainer"
                                      ></the-mask>
                                      <div class="errorContainer"></div>
                                    </div>
                                  </div>
                                </div>
                                <div class="recomendation">
                                  <!--div class="img-content">
                                    <img src="/images/recomendation_img.png" alt="recomendation_img" />
                                  </div-->
                                  <div class="text-content">
                                    <h5>Recuerda</h5>
                                    <div class="item">
                                      <div class="bullet-yellow"> </div>
                                      <span><b>No utilizar emails corporativos.</b> Puede que nuestros emails no te lleguen.</span>
                                    </div>
                                    <div class="item">
                                      <div class="bullet-yellow"> </div>
                                      <span>Revisa tu casilla de <b>Spam, Promociones o Correos no deseados</b></span>
                                    </div>
                                    <div class="item">
                                      <div class="bullet-yellow"> </div>
                                      <span>Si continuas sin recibir nuestros correos, puedes comunicarte al <b>+56 2 2994 9850</b></span>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="email">Email</label>
                                      <div class="d-flex" style="width: 100%;">
                                        <input
                                            type="email"
                                            v-model="financingPartyData.email"
                                            name="email"
                                            maxlength="50"
                                            class="withErrorContainer"
                                            style="background-color: #ffffff; width: 100%;"
                                        />
                                      </div>
                                      <div class="errorContainer"></div>
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Dirección</label>
                                      <input
                                          v-model="financingPartyData.address"
                                          type="text"
                                          name="direccion"
                                          maxlength="30"
                                      />
                                    </div>
                                  </div>

                                </div>


                                <div class="row">                                
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Número</label>
                                      <input
                                          v-model="financingPartyData.address2"
                                          type="text"
                                          name="dirNumero"
                                          onkeypress="return /[0-9]/i.test(event.key)"
                                          maxlength="5"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Departamento</label>
                                      <input
                                          v-model="financingPartyData.address3"
                                          type="text"
                                          name="dirDepartamento"
                                          maxlength="5"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div class="pdv-form-group">
                                  <div class="row">
                                    <div class="col-md-6 col-12">
                                      <div class="form-group custom-select2-container">
                                        <label for="financingRegionSelect">Región</label>
                                        <select
                                            id="financingRegionSelect"
                                            ref="financingRegionSelect"
                                            class="pdv-custom-select"
                                            v-model="financingPartyData.regionId"
                                            v-select2="financingPartyData.regionId"
                                            :name="'region-' + timestamp"
                                            @change="onSelectRegion(financingPartyData.regionId)"
                                        >
                                          <option value="">Selecciona tu región</option>
                                          <option
                                              v-for="r in availableRegions"
                                              :key="r.id"
                                              :value="r.id"
                                          >
                                            {{ r.name }}
                                          </option>
                                        </select>
                                        <div class="errorContainer"></div>
                                      </div>
                                    </div>

                                    <div class="col-md-6 col-12">
                                      <div class="form-group custom-select2-container">
                                        <label for="financingCitySelect">Ciudad</label>
                                        <select
                                            id="financingCitySelect"
                                            ref="financingCitySelect"
                                            class="pdv-custom-select"
                                            v-model="financingPartyData.cityId"
                                            v-select2="financingPartyData.cityId"
                                            :name="'ciudad-' + timestamp"
                                            :disabled="!financingPartyData.regionId"
                                            @change="onsSelectFinancingCity(financingPartyData.cityId)"
                                        >
                                          <option value="">Selecciona tu ciudad</option>
                                          <option
                                              v-for="c in availableCities"
                                              :key="c.id"
                                              :value="c.id"
                                          >
                                            {{ c.name }}
                                          </option>
                                        </select>
                                        <div class="errorContainer"></div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row form-group">
                                    <div class="col-10 col-md-6">
                                      <div class="form-group custom-select2-container">
                                        <label for="financingCommuneSelect">Comuna</label>
                                        <select
                                            id="financingCommuneSelect"
                                            ref="financingCommuneSelect"
                                            class="pdv-custom-select"
                                            v-model="financingPartyData.communeId"
                                            v-select2="financingPartyData.communeId"
                                            :name="'comuna-' + timestamp"
                                            :disabled="!financingPartyData.regionId"
                                            @change="onsSelectFinancingComuna(financingPartyData.communeId)"
                                        >
                                          <option value="">Selecciona tu comuna</option>
                                          <option
                                              v-for="c in availableCommunes"
                                              :key="c.id"
                                              :value="c.id"
                                          >
                                            {{ c.name }}
                                          </option>
                                        </select>
                                        <div class="errorContainer"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-actions">
                                  <button
                                      type="button"
                                      class="btn-step2-volver"
                                      @click="$router.push({ name: 'Outlet1' })"
                                  >
                                    <span class="btn-arrow">←</span> Volver
                                  </button>
                                  <button
                                      type="submit"
                                      class="btn-step2-continuar"
                                      :disabled="guardo_Estudiante == false"
                                  >
                                    Continuar 
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            
          </div>
        </div>
      </div>

      <Loader v-if="loadingPack"/>

  </layout-default>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as moment from "moment";
import LayoutDefault from "@/layouts/Default";
import formValidation from "@/mixins/formValidation";
import vueMask from "vue-jquery-mask";
import { orderBy } from "@/helpers";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Countdown from "countdown-vue";
import Loader from '@/components/Loader';

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);
// import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

global.jQuery = require("jquery");
const $ = global.jQuery;
window.$ = $;
import Cookies from "js-cookie";

export default {
  name: "OutletStep2",
  components: {
    Countdown,
    LayoutDefault,
    vueMask,
    Loader,
  },

  data() {
    return {
      guardo_Estudiante: false,
      uniqueEmail: true,
      errorMens: false,
      errorMensAlumn: false,
      timestamp: Date.now(),
      sharedRegions: [],
      availableRegions: [],
      availableCities: [],
      availableCommunes: [],
      availableStudentsRegion: [],
      availableStudentsCommunes: [],
      availableStudentsColleges: [],
      availableStudentsServerColleges: [],
      isLoadingCache: false,
      financingPartyData: {
        name: "",
        fatherLastName: null,
        motherLastName: null,
        lastName: null,
        rut: "",
        email: null,
        phone: "+569 ",
        regionId: null,
        cityId: null,
        communeId: null,
        address: null,
        address2: null,
        address3: null
      },
      studentData: {
        email: "",
        phone: "+569 ",
        establishment: "",
        graduationYear: new Date().getFullYear() + 1,
        birthday: "",
        careerPath: "pdv",
        regionId: null,
        communeId: null,
        averageScore: null,
        rut: '',
        name: '',
        fatherLastName: '',
      },
      studentsData: [],
      webpay: null,
      accept: false,
      formsComplete: [false],
      dateMaskOptions: {
        // These are the initial regex
        translation: {
          D: { pattern: /[0-3]/ },
          A: { pattern: /[0-9]/ },
          M: { pattern: /[0-1]/ },
          O: { pattern: /[0-9]/ },
          Y: { pattern: /[1-2]/ },
          E: { pattern: /[90]/ },
          X: { pattern: /[0-9]/ },
          R: { pattern: /[0-9]/ }
        },

        // Here is when the magic happen, changing regex of some characters if needed
        // Documentation on -> https://igorescobar.github.io/jQuery-Mask-Plugin/docs.html#callback-examples
        // To see original function taken as example and before modified -> https://gist.github.com/igorescobar/6450250#gistcomment-2307273
        onKeyPress: function(cep, event, currentField, options) {
          if (!cep) return;
          let m = cep.match(/(\d{1})/g);
          if (!m) return;

          if (parseInt(m[0]) === 3) {
            options.translation.A.pattern = /[0-1]/;
          } else if (parseInt(m[0]) === 0) {
            options.translation.A.pattern = /[1-9]/;
          } else {
            options.translation.A.pattern = /[0-9]/;
          }

          if (parseInt(m[2]) === 1) {
            options.translation.O.pattern = /[0-2]/;
          } else {
            options.translation.O.pattern = /[1-9]/;
          }

          if (parseInt(m[4]) === 2) {
            options.translation.E.pattern = /[0]/;
          } else {
            options.translation.E.pattern = /[9]/;
          }

          if (parseInt(m[5]) === 0) {
            options.translation.X.pattern = /[0-9]/;
          } else {
            options.translation.X.pattern = /[0-9]/;
          }

          if (parseInt(m[6]) === 0 && parseInt(m[5]) === 0) {
            options.translation.R.pattern = /[0-9]/;
          } else {
            options.translation.R.pattern = /[0-9]/;
          }

          let temp_value = currentField.val();
          currentField.val("");
          currentField.unmask().mask("DA/MO/YEXR", options);
          currentField.val(temp_value);
        }
      },
      averageScoreMask: '##',
      showModal: false,
      loadingPack: true,
      studentSectionExpanded: false,
    };
  },
  mixins: [formValidation],
  computed: {
    ...mapState(["quotasTimeRemaining"]),
    ruleBook() {
      if(!this.selectedLocation){
        return process.env.VUE_APP_PDV_RULEBOOK_CONTRACT;
      } else {
        if(this.selectedLocation.name.includes('San Miguel')){
          return process.env.VUE_APP_PDV_RULEBOOK_CONTRACT_SM;
        } else {
          return process.env.VUE_APP_PDV_RULEBOOK_CONTRACT;
        }
      }
    },
    selectYears() {
      let currentYear = new Date().getFullYear();
      return Array(33)
          .fill({})
          .map((x, i) => currentYear + 5 - i);
    },
    students() {
      return this.$store.state.students;
    },
    selectedProgram() {
      return this.$store.state.selectedProgram;
    },
    selectedLocation() {
      return this.$store.state.selectedLocation;
    },
    prices(){
      return this.$store.state.students[0].prices
    }
  },
  async created() {
    //this.$store.dispatch("hideBackpack");
    this.availableRegions = [];
    const { data: regions } = await this.Axios.get("/regions");
    this.availableRegions = orderBy([...regions], "name");
    this.sharedRegions = this.availableRegions;
    this.loadCachedData();
  },
  async mounted() {
    this.$Progress.finish();
    this.isLoadingCache = true;
    
    if(this.$route.query.packId){
      const {data: pack } = await this.Axios.get(`/dashadmin/fullpacks/${this.$route.query.packId}`);
      await this.setLocalstorageData(pack);
    } else {
      this.$router.push({ name: 'Outlet1' });
    }

    // Restaurar datos de región/comuna/colegio del estudiante si existen
    if (this.studentData.regionId) {
      await this.onSelectStudentRegion(this.studentData.regionId);
      if (this.studentData.comuneId) {
        await this.onSelectCommune(this.studentData.comuneId);
      }
    }

    // Restaurar datos de región/ciudad/comuna del apoderado si existen
    if (this.financingPartyData.regionId) {
      await this.onSelectRegion(this.financingPartyData.regionId);
    }
    
    this.isLoadingCache = false;
    
    //this.interval = setInterval(this.discountSeconds, 1000);
    $(document).ready(() => {
      this.$nextTick(() => {
        // Inicializar todos los Select2
        this.initStudentRegionSelect2();
        this.initStudentCommuneSelect2();
        this.initStudentCollegeSelect2();
        this.initFinancingRegionSelect2();
        this.initFinancingCitySelect2();
        this.initFinancingCommuneSelect2();
        
        // Después de inicializar, establecer los valores si existen
        if (this.studentData.regionId) {
          $('#studentRegionSelect').val(this.studentData.regionId).trigger('change.select2');
        }
        if (this.studentData.comuneId) {
          $('#studentCommuneSelect').val(this.studentData.comuneId).trigger('change.select2');
        }
        if (this.studentData.establishment) {
          $('#studentCollegeSelect').val(this.studentData.establishment).trigger('change.select2');
        }
        if (this.financingPartyData.regionId) {
          $('#financingRegionSelect').val(this.financingPartyData.regionId).trigger('change.select2');
        }
        if (this.financingPartyData.cityId) {
          $('#financingCitySelect').val(this.financingPartyData.cityId).trigger('change.select2');
        }
        if (this.financingPartyData.communeId) {
          $('#financingCommuneSelect').val(this.financingPartyData.communeId).trigger('change.select2');
        }
      });

      $("#graduationYear").select2({
        placeholder: "Selecciona tu año de egreso",
        width: "100%",
        minimumResultsForSearch: 0,
        language: { noResults: () => "Sin resultados", inputTooShort: () => "Escribe para buscar" }
      });

      this.validateForm(
          $("#programInscription"),
          {
            ["nombre-" + this.timestamp]: {
              required: true,
              lettersonly: true
            },

            apellidoPaterno: {
              required: true,
              lettersonly: true
            },

            apellidoMaterno: {
              required: true,
              lettersonly: true
            },

            direccion: {
              required: true
            },
            email: {
              minlength: 8,
              required: true,
              email: function(value, element) {
                // return /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test(
                return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
                  value
                );
              }
            },
            ["region-" + this.timestamp]: {
              required: true
            },
            ["ciudad-" + this.timestamp]: {
              required: true
            },
            ["comuna-" + this.timestamp]: {
              required: true
            },
            rut: {
              required: true,
              rut: true
            },

            cel: {
              minlength: 13,
              required: true
            },

            terminos: {
              required: true
            }
          },

          {
            apellidoPaterno: {
              required: "Debes ingresar tu apellido paterno",
              lettersonly: "Solo se permiten letras"
            },

            apellidoMaterno: {
              required: "Debes ingresar tu apellido materno",
              lettersonly: "Solo se permiten letras"
            },

            nombre: {
              required: "Ingresa tu nombre",
              lettersonly: "Solo se permiten letras"
            },
            direccion: {
              required: "Debes ingresar una dirección"
            },
            email: {
              minlength: "Debes ingresar un correo valido",
              required: "Debes ingresar un correo",
              email: "Debes ingresar un correo valido"
            },
            ["region-" + this.timestamp]: {
              required: "Debes seleccionar una región"
            },
            ["ciudad-" + this.timestamp]: {
              required: "Debes seleccionar una ciudad"
            },
            ["comuna-" + this.timestamp]: {
              required: "Debes seleccionar una comuna"
            },
            rut: {
              required: "Debes ingresar el RUT",
              rut: "El RUT ingresado no es válido"
            },

            cel: {
              minlength: "Debes ingresar un numero de celular válido",
              required: "Debes ingresar un numero de celular"
            },

            terminos: {
              required: "Debes aceptar los terminos y condiciones"
            }
          }
      );

      this.validateForm(
          $("#alumnForm"),
          {
            email: {
              email: function(value, element) {
                return /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test(
                    value
                );
              },
              minlength: 8,
              required: true
            },
            cel: {
              minlength: 13,
              required: true
            },

            ["colegio-" + this.timestamp]: {
              required: true
            },
            ["region-" + this.timestamp]: {
              required: true
            },
            ["comuna-" + this.timestamp]: {
              required: true
            },

            promedio: {
              required: true
            },

            añoGraduacion: {
              required: true
            },

            fecha: {
              minlength: 10,
              required: true
            },

            genero: {
              required: true
            }
          },

          {
            email: {
              minlength: "Debes ingresar un correo valido",
              required: "Debes ingresar un correo",
              email: "Debes ingresar un correo valido"
            },
            cel: {
              minlength: "Debes ingresar un número de celular válido",
              required: "Debes ingresar un número de celular"
            },

            ["colegio-" + this.timestamp]: {
              required: "Debes ingresar un colegio"
            },
            ["region-" + this.timestamp]: {
              required: "Debes ingresar una región"
            },
            ["comuna-" + this.timestamp]: {
              required: "Debes ingresar una comuna"
            },

            promedio: {
              required: "Debes ingresar tu promedio"
            },

            añoGraduacion: {
              required: "Debes seleccionar un año"
            },

            fecha: {
              minlength: "Debe ingresar la fecha correctamente",
              required: "Debes ingresar tu fecha de nacimiento"
            },

            genero: {
              required: "Debes seleccionar tu género"
            }
          }
      );
   
    });
    const zoomScript = document.createElement("script");
    zoomScript.src = "https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js";
    zoomScript.setAttribute("data-apikey", "G4nAX1GiTf6ib-GJAcV4Qw");
    zoomScript.setAttribute("data-env", "us01");
    zoomScript.async = true;
    document.body.appendChild(zoomScript);
  },
  destroyed() {
  },
  beforeDestroy() {
    const script = document.querySelector('script[src="https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js"]');
    if (script) {
      script.remove();  // Elimina el script al salir de la página
    }
  },

  methods: {
    ...mapActions(["setQuotasTimeRemaining", "setCoursesNotAvailables"]),
    loadCachedData() {
      try {
        const cachedData = localStorage.getItem('outletStep2Data');
        if (cachedData) {
          const data = JSON.parse(cachedData);
          if (data.studentData) {
            this.studentData = { ...this.studentData, ...data.studentData };
          }
          if (data.financingPartyData) {
            this.financingPartyData = { ...this.financingPartyData, ...data.financingPartyData };
          }
          if (data.guardo_Estudiante !== undefined) {
            this.guardo_Estudiante = data.guardo_Estudiante;
          }
        }
      } catch (error) {
        console.error('Error loading cached data:', error);
      }
    },
    saveCachedData() {
      try {
        const dataToCache = {
          studentData: this.studentData,
          financingPartyData: this.financingPartyData,
          guardo_Estudiante: this.guardo_Estudiante,
        };
        localStorage.setItem('outletStep2Data', JSON.stringify(dataToCache));
      } catch (error) {
        console.error('Error saving cached data:', error);
      }
    },
    async setLocalstorageData(pack){
      localStorage.setItem('pack', JSON.stringify(pack));
      let ids = []
      let idsLocations = []
      let selectedSubjesA = []
      //recorrer los detalles
      pack.PackDetails.forEach(detail=> {
        ids.push(detail.Course.SubjectId)
        idsLocations.push(detail.LocationId)
      });
      try {
        await this.$store.dispatch("clearSelectedSubjects");
        await this.$store.dispatch("clearSubjectsWithCourses");
        
        //Buscar las asignaturas con cursos por cada detalle
        const {data} = await this.Axios.get(`/subjectsByIds?ids=${ids.join(',')}&idsLocations=${idsLocations.join(',')}`);
        this.loadingPack = false;
        let subjestFromApi = [];
        subjestFromApi = data;
        subjestFromApi.forEach(subjetc=> {
          const newSubject = {
            ...subjetc,
            courses: subjetc.Courses
          }
          this.$store.dispatch("addSubject", newSubject);
          this.$store.dispatch("addSubjectWithCourses", newSubject);
          selectedSubjesA.push(newSubject)
        });
        await this.$store.dispatch("addSelectedProgramInfo", pack.PackDetails[0].Course.Program);
        await this.$store.dispatch("saveSelectedLocation", pack.Location);
        
        this.$store.dispatch("clearSelectedCourses");

        // Fetch individual courses with Schedules (mismo patrón que new-version)
        const courseDetailPromises = pack.PackDetails.map(async (detail) => {
          const course = detail.Course;
          let schedules = course.Schedules || [];

          // Fallback 1: buscar en subjectsByIds (ahora incluye Schedules tras fix backend)
          if (schedules.length === 0) {
            for (const subject of subjestFromApi) {
              const found = (subject.Courses || []).find(c => c.id === course.id);
              if (found?.Schedules?.length) {
                schedules = found.Schedules;
                break;
              }
            }
          }

          // Fallback 2: fetch directo del curso — igual que hace new-version con course.Schedules
          if (schedules.length === 0) {
            try {
              const { data: fullCourse } = await this.Axios.get(`/courses/${course.id}`);
              if (fullCourse?.Schedules?.length) {
                schedules = fullCourse.Schedules;
              }
            } catch (e) {
              console.warn(`No se pudieron obtener schedules para course ${course.id}:`, e);
            }
          }

          return { course, schedules };
        });

        const courseDetails = await Promise.all(courseDetailPromises);
        courseDetails.forEach(({ course, schedules }) => {
          const mappedCourse = {
            courseId: course.id,
            hour: schedules.map(s => `${s.dayOfWeek} ${s.startTime?.slice(0, 5)}-${s.endTime?.slice(0, 5)}`).join(', '),
            lastSeats: false,
            days: [...new Set(schedules.map(s => s.dayOfWeek))],
            subjectName: course.Subject?.name,
            coursePdvId: course.pdvId,
            coursePdvCode: course.pdvCode || course.code,
            subjectId: course.SubjectId || course.Subject?.id,
            blocks: schedules.map(s => s.block).filter(b => b != null),
            schedulesPerDayOfThisCourse: schedules.map(s => `${s.dayOfWeek} ${s.startTime?.slice(0, -3)} a ${s.endTime?.slice(0, -3)}`),
            coursesWithSameSchedule: [],
            hoursPerDay: schedules.map(s => ({
              day: s.dayOfWeek,
              startTime: s.startTime,
              endTime: s.endTime,
              subject: course.Subject?.name,
              block: s.block,
            })),
          };
          this.$store.dispatch("saveCourseSelected", mappedCourse);
        });

      } catch (error) {
        console.error('[Step2] ERROR en setLocalstorageData:', error)
      }
    },
    async saveFormInfo() {
      try {
        const res = await this.createStudent();
        await this.$store.dispatch("addStudent", {
          ...res.data,
          selectedLocation: this.selectedLocation || this.$store.state.selectedLocation,
        });
        const {data: order} = await this.Axios.post("/orders", {
          sessionState: JSON.stringify({students: [{ program: this.selectedProgram }] }),
          initialStudentId: res.data.id
        });
        Cookies.set("sessionId", order.sessionId);
        Cookies.set("orderId", order.id);
        localStorage.ordenID = order.id;

        this.guardo_Estudiante = true;
        this.saveCachedData();

        return true;

      } catch (error) {
        alert("Error al guardar los datos del estudiante");
        return false
      }
    },
    createStudent() {
      const body = {
        ...this.studentData,
        
      };
      return new Promise((resolve, reject) => {
          this.Axios.post("/students", body)
              .then(res => {
                  resolve(res);
              })
              .catch(error => {
                  if (error.response.status === 400) {
                      if (
                          error.response.data.message ===
                          "Error - Email address already in use!"
                      ) {
                          alert(
                              "El correo: " +
                              error.response.data.problemField.email +
                              " ya se encuentra registrado"
                          );
                      }
                  }
                  reject(error);
              });
      });
    },    
    dateFormat(val) {
      let birthday = val;
      let format = "YYYY-MM-DD";
      if (birthday) {
        format =
            birthday.split("-")[0].length === 4 ? "YYYY-MM-DD" : "DD-MM-YYYY";
      }
      return moment(birthday, format).format("DD-MM-YYYY");
    },
    buildFinancingPartyPayload() {
      const d = this.financingPartyData;
      const toInt = (v) => {
        if (v == null || v === "") return null;
        const n = parseInt(v, 10);
        return Number.isNaN(n) ? null : n;
      };
      const cleanPhone = (v) => {
        if (!v || typeof v !== "string") return null;
        const s = v.trim();
        if (!s) return null;
        const digits = s.replace(/\D/g, "");
        if (digits.length >= 8) return "+56" + digits;
        return s;
      };
      // Construir lastName con fatherLastName y motherLastName
      const lastName = `${d.fatherLastName || ""} ${d.motherLastName || ""}`.trim() || null;
      
      return {
        name: d.name || null,
        fatherLastName: d.fatherLastName || null,
        motherLastName: d.motherLastName || null,
        lastName: lastName,
        rut: (d.rut && d.rut.trim()) || null,
        email: (d.email && d.email.trim()) || null,
        phone: cleanPhone(d.phone) || (d.phone && d.phone.trim()) || null,
        regionId: toInt(d.regionId),
        cityId: toInt(d.cityId),
        communeId: toInt(d.communeId),
        address: (d.address && d.address.trim()) || null,
        address2: (d.address2 && d.address2.trim()) || null,
        address3: (d.address3 && d.address3.trim()) || null,
      };
    },
    async saveFinancingParty(gestionarCollapse) {
      // Construir lastName con ambos apellidos antes de crear el payload
      this.financingPartyData.lastName = `${this.financingPartyData.fatherLastName || ""} ${this.financingPartyData.motherLastName || ""}`.trim();
      const payload = this.buildFinancingPartyPayload();
      try {
        // Verificar si ya existe un apoderado con el mismo RUT
        let existingFinancingParty = null;
        try {
          const { data } = await this.Axios.get(
            `/financingParties/rut/${encodeURIComponent(this.financingPartyData.rut)}`
          );
          existingFinancingParty = data;
        } catch (checkError) {
          if (!checkError.response || checkError.response.status !== 404) {
            throw checkError;
          }
          // 404 significa que no existe → se creará
        }

        let financingParty;
        if (existingFinancingParty && existingFinancingParty.id) {
          // Ya existe → actualizar
          const { data } = await this.Axios.put(
            `/financingParties/${existingFinancingParty.id}`,
            payload
          );
          financingParty = data;
        } else {
          // No existe → crear
          const { data } = await this.Axios.post("/financingParties", payload);
          financingParty = data;
        }

        // Guardar la respuesta completa que incluye el ID
        await this.$store.dispatch("addFinancingPartyInfo", financingParty);
        await this.$store.dispatch("addInfoToFullOrder", {
          financingParty: financingParty,
        });

        if(gestionarCollapse){
          // Navegación tras guardar (sin acordeón)
        }

        return true;
      } catch (error) {
        console.error("saveFinancingParty error:", error);
        const res = error.response;
        if (res && res.status === 400 && res.data) {
          if (res.data.message === "email must be unique") {
            this.uniqueEmail = false;
            this.$swal.fire({
              position: "center",
              icon: "warning",
              title: "¡Atención!",
              html:
                  "El correo " +
                  "<b>" +
                  (res.data.problemField && res.data.problemField.email ? res.data.problemField.email : this.financingPartyData.email) +
                  "</b>" +
                  " ya se encuentra registrado",
              showConfirmButton: true
            });
            return false;
          }
          const msg = typeof res.data.message === "string"
            ? res.data.message
            : (res.data.errors && Array.isArray(res.data.errors))
              ? res.data.errors.map(e => e.message || e.msg || JSON.stringify(e)).join("\n")
              : "Revisa los datos del apoderado e inténtalo de nuevo.";
          this.$swal.fire({
            position: "center",
            icon: "error",
            title: "Error al guardar",
            text: msg,
            showConfirmButton: true
          });
          return false;
        }
        this.$swal.fire({
          position: "center",
          icon: "error",
          title: "Error al guardar",
          text: "No se pudo guardar el apoderado. Revisa los datos e inténtalo de nuevo.",
          showConfirmButton: true
        });
        return false;
      }
    },
    async saveStudent(studentIndex) {
      try {
         let currentStudent = this.studentsData[studentIndex];

         let info = {
           student: this.students[studentIndex],
           append: { ...currentStudent }
         };

        const { data: student } = await this.Axios.post(`/students`, {
          ...info.student,
          ...info.append
         });

         info.student = student;

        await this.$store.dispatch("addInfoToStudent", info);

         return true;
       } catch (error) {
         if (error.response.status === 400) {
           if (
               error.response.data.message ===
              "Error - Email address already in use!"
          ) {
            alert(
                 "El correo: " +
                error.response.data.problemField.email +
                 " ya se encuentra registrado"
             );
          }
         }
         return false;
       }
    },
    discountSeconds() {
      const currentTime = moment(this.quotasTimeRemaining, "mm:ss").subtract(
          1,
          "second"
      );
      this.setQuotasTimeRemaining(currentTime.format("mm:ss"));
    },
    async onSelectRegion(id) {
      this.availableCities = [];
      this.availableCommunes = [];
      this.financingPartyData.regionId = id;
      // Solo limpiar valores dependientes si NO estamos cargando desde caché
      if (!this.isLoadingCache) {
        this.financingPartyData.cityId = null;
        this.financingPartyData.communeId = null;
      }
      const regionId = this.financingPartyData.regionId;
      if (regionId) {
        const { data: cities } = await this.Axios.get(`/cities/${regionId}`);
        this.availableCities = orderBy([...cities], "name");
        const { data: communes } = await this.Axios.get(
            `/communes/${regionId}`
        );
        this.availableCommunes = orderBy([...communes], "name");
        if (!this.isLoadingCache) {
          this.$nextTick(() => {
            this.initFinancingCitySelect2();
            this.initFinancingCommuneSelect2();
          });
        }
      }
      if (!this.isLoadingCache) {
        this.saveCachedData();
      }
    },
    initStudentRegionSelect2() {
      const el = this.$refs.studentRegionSelect;
      if (!el) return;
      if ($(el).data("select2")) $(el).select2("destroy");
      $(el).select2({
        placeholder: "Selecciona tu región",
        width: "100%",
        allowClear: true,
        minimumResultsForSearch: 0,
        language: { noResults: () => "Sin resultados", inputTooShort: () => "Escribe para buscar" }
      });
    },
    initStudentCommuneSelect2() {
      const el = this.$refs.studentCommuneSelect;
      if (!el) return;
      if ($(el).data("select2")) $(el).select2("destroy");
      $(el).select2({
        placeholder: "Selecciona tu comuna",
        width: "100%",
        allowClear: true,
        minimumResultsForSearch: 0,
        language: { noResults: () => "Sin resultados", inputTooShort: () => "Escribe para buscar" }
      });
    },
    initStudentCollegeSelect2() {
      const el = this.$refs.studentCollegeSelect;
      if (!el) return;
      if ($(el).data("select2")) $(el).select2("destroy");
      $(el).select2({
        placeholder: "Selecciona tu colegio",
        width: "100%",
        allowClear: true,
        minimumResultsForSearch: 0,
        language: { noResults: () => "Sin resultados", inputTooShort: () => "Escribe para buscar" }
      });
    },
    initFinancingRegionSelect2() {
      const el = this.$refs.financingRegionSelect;
      if (!el) return;
      if ($(el).data("select2")) $(el).select2("destroy");
      $(el).select2({
        placeholder: "Selecciona tu región",
        width: "100%",
        allowClear: true,
        minimumResultsForSearch: 0,
        language: { noResults: () => "Sin resultados", inputTooShort: () => "Escribe para buscar" }
      });
    },
    initFinancingCitySelect2() {
      const el = this.$refs.financingCitySelect;
      if (!el) return;
      if ($(el).data("select2")) $(el).select2("destroy");
      $(el).select2({
        placeholder: "Selecciona tu ciudad",
        width: "100%",
        allowClear: true,
        minimumResultsForSearch: 0,
        language: { noResults: () => "Sin resultados", inputTooShort: () => "Escribe para buscar" }
      });
    },
    initFinancingCommuneSelect2() {
      const el = this.$refs.financingCommuneSelect;
      if (!el) return;
      if ($(el).data("select2")) $(el).select2("destroy");
      $(el).select2({
        placeholder: "Selecciona tu comuna",
        width: "100%",
        allowClear: true,
        minimumResultsForSearch: 0,
        language: { noResults: () => "Sin resultados", inputTooShort: () => "Escribe para buscar" }
      });
    },
    clearStudenRegion(){
      this.studentData.regionId = null
    },
    async onSelectStudentRegion(id) {
      this.studentData.regionId = id;
      // Solo limpiar valores dependientes si NO estamos cargando desde caché
      if (!this.isLoadingCache) {
        this.studentData.comuneId = null;
        this.studentData.establishment = null;
      }
      this.availableCommunes = [];
      this.availableStudentsColleges = [];
      const regionId = id;
      if (regionId) {
        const { data: communes } = await this.Axios.get(`/communes/${regionId}`);
        this.availableCommunes = orderBy(communes, "name");
        if (!this.isLoadingCache) {
          this.$nextTick(() => this.initStudentCommuneSelect2());
        }
      }
      if (!this.isLoadingCache) {
        this.saveCachedData();
      }
    },
    clearStudenComune(){
      this.studentData.communeId = null
    },
    async onSelectCommune(id) {
      this.studentData.communeId = id;
      // Solo limpiar colegio si NO estamos cargando desde caché
      if (!this.isLoadingCache) {
        this.studentData.establishment = null;
      }
      const communeId = id;
      this.availableStudentsColleges = [];
      if (communeId) {
        const { data } = await this.Axios.get(`colleges/${communeId}`);
        this.availableStudentsColleges = orderBy(data, "name");
        if (!this.isLoadingCache) {
          this.$nextTick(() => this.initStudentCollegeSelect2());
        }
      }
      if (!this.isLoadingCache) {
        this.saveCachedData();
      }
    },
    clearStudenColege(){
      this.studentData.establishment = null
    },
    async onSelectColege(id) {
      this.studentData.establishment = id.toString();
      if (!this.isLoadingCache) {
        this.saveCachedData();
      }
    },
    async onSaveForm(formIndex) {
      if (formIndex === 0) {
        let ok = await this.saveFinancingParty(true);
        if (ok) {
          $(window).scrollTop(0);
          this.$router.push({ name: 'Outlet3' });
        }
      } else {
        let ok = await  this.saveFormInfo();
        if (ok) {
          $(window).scrollTop(0);
        }
      }
    },
    collegesHandler(id, studentId) {
      this.studentsData[studentId].establishment = id.toString();
      const establishment = this.studentsData[studentId].establishment;
      if (establishment) {
        let college = this.availableStudentsServerColleges[studentId].filter(
            college => {
              return college.id === this.selectedCommune;
            }
        );
        this.$set(this.availableStudentsColleges, studentId, college);
      } else {
        this.$set(
            this.availableStudentsColleges,
            studentId,
            this.availableStudentsServerColleges[studentId]
        );
      }
    },
    getPaternNem(v){
      if(this.studentsData.length === 0){
        return /[0-9]/
      }else if(this.studentsData[0].averageScore === null){
        return /[0-9]/
      } else {
        if(this.studentsData[0].averageScore.includes('7')) {
          this.studentsData[0].averageScore = '7.0'
          return    /^-?(?:0\d*|0)$/
        } else {
          return /[0-9]/
        }
      }
    },
    clearFinancingPartyRegion(){
      this.financingPartyData.regionId = null
    },
    clearFinancingPartyCity(){
      this.financingPartyData.cityId = null
    },
    clearFinancingPartyComuna(){
      this.financingPartyData.communeId = null
    },
    onsSelectFinancingCity(id){
      this.financingPartyData.cityId = id;
      if (!this.isLoadingCache) {
        this.saveCachedData();
      }
    },
    onsSelectFinancingComuna(id){
      this.financingPartyData.communeId = id;
      if (!this.isLoadingCache) {
        this.saveCachedData();
      }
    },
  },
  beforeDestroy() {
  },
  filters: {
    timeRemaining(time) {
      return moment(time, "mm:ss").format("mm’ ss’’");
    }
  },
  watch: {
    sharedRegions(value) {
      if (value.length) {
        this.studentsData.forEach((student, i) => {
          this.$set(this.availableStudentsRegion, i, value);
        });
      }
    },
    guardo_Estudiante(val) {
      if (val) {
        this.$nextTick(() => {
          this.initFinancingRegionSelect2();
          this.initFinancingCitySelect2();
          this.initFinancingCommuneSelect2();
        });
      }
      if (!this.isLoadingCache) {
        this.saveCachedData();
      }
    },
    studentData: {
      handler() {
        if (!this.isLoadingCache) {
          this.saveCachedData();
        }
      },
      deep: true
    },
    financingPartyData: {
      handler() {
        if (!this.isLoadingCache) {
          this.saveCachedData();
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="scss">
.swal2-styled.swal2-confirm {
  background-color: #000000 !important;
  border-radius: 2px !important;
  color: #ffd61a !important;
  min-width: 185px;
}
.vuejs-countdown {
  // margin: 8px 0 0 90px !important;
  display: block;
  .text {
    display: none;
  }
  .digit {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 12px !important;

    color: #666666;
    line-height: 12px !important;
  }
  li::after {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 12px !important;
    color: #666666;
    line-height: 12px !important;
  }
}

.pdv-form-group .form-group input[type=search]{
  border-radius: 100px !important;
  border: 2px solid $neutral30 !important;
  height: 48px !important;
  padding: 12px 24px !important;
}

/* Forzar color rojo en mensajes de error de este paso (no scoped, afecta labels de jQuery) */
.form-section label.error,
.form-section .validation-message,
.form-section .error-otp {
  color: #ef4444 !important;
}

.step-4-content {
  .form-group label{
    color: $neutralBlack !important;
    font-family: 'Poppins-Medium', sans-serif !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 22px !important;
  }
}

</style>
<style scoped lang="scss">

/* Sin borde en el contenedor del formulario (acordeón y cards) */
.custom-acordeon {
  min-width: 0;
}
.custom-acordeon .accordion {
  border: none !important;
  min-width: 0;
}
.custom-acordeon .card {
  border: none !important;
  border-radius: 0 !important;
  min-width: 0;
}
.custom-acordeon .card-header {
  border: none !important;
}
.custom-acordeon .card-body {
  border: none !important;
  min-width: 0;
}
.custom-acordeon .acordeon-button {
  border: none !important;
}

/* Bloques del acordeón: diferenciación visual por sección */
.accordion-block {
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 0;
}
.accordion-block--student {
  border: none;
}
.accordion-block--student.accordion-block--bordered {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.accordion-block--apoderado {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.accordion-block-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #6b7280;
  color: #fff;
  font-family: 'Poppins-Bold', sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  margin-right: 12px;
  flex-shrink: 0;
}
.accordion-block-badge--apoderado {
  background: #6b7280;
}
.accordion-block .form-section-title {
  display: flex;
  align-items: center;
  text-align: left !important;
  justify-content: flex-start;
}
.outlet-student-accordion .accordion-header-outlet .accordion-title {
  display: flex;
  align-items: center;
}
.acordeon-separator {
  height: 1px;
  background: rgba(0, 0, 0, 0.08);
  margin: 24px 0;
}

/* Formularios más anchos, centrados (sin cortar inputs a la derecha) */
.form-section {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
  padding: 0 16px;
  min-width: 0; /* permite que el flex child no desborde */
}
@media (min-width: 1016px) {
  .form-section {
    max-width: 960px;
    margin-left: auto;
    margin-right: auto;
  }
}
@media (max-width: 768px) {
  .form-section {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
}
.form-section form {
  width: 100%;
  box-sizing: border-box;
}

/* Mensajes de error: mismo estilo que inscripción paso 2 */
.error-otp {
  font-size: 0.75rem;
  color: #f70202;
  margin-top: 0.25rem;
  display: block;
}

/* Bordes y textos en error: igual que inscripción/paso-2 */
.form-section .form-group.error input,
.form-section .form-group.error textarea,
.form-section .form-group.error select,
.form-section .form-group.error .vue-mask input,
.form-section .form-group.error .the-mask input {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
}

.form-section .form-group.error .select2-container--default .select2-selection--single {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
}

.form-section .form-group.error .error-otp,
.form-section .form-group.error label.error,
.form-section .form-group.error .validation-message {
  color: #ef4444 !important;
}

/* Forzar color rojo en cualquier mensaje de error dentro del formulario */
.form-section label.error,
.form-section .validation-message {
  color: #ef4444 !important;
}

.form-section-title {
  font-family: 'Poppins-Bold', sans-serif;
  font-size: 1.75rem !important;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 1rem 0;
  text-align: center !important;
  width: 100%;
}

/* Acordeón sección estudiante (después de Guardar) */
.outlet-student-accordion .accordion-header-outlet {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0.5rem 0;
  cursor: pointer;
  user-select: none;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}
.outlet-student-accordion .accordion-header-outlet:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.outlet-student-accordion .accordion-header-outlet .accordion-title {
  margin: 0 !important;
  text-align: left !important;
}
.outlet-student-accordion .accordion-arrow {
  flex-shrink: 0;
  font-size: 0.875rem;
  color: #6b7280;
  transition: transform 0.25s ease;
}
.outlet-student-accordion .accordion-arrow.open {
  transform: rotate(180deg);
}
.outlet-student-accordion .accordion-body-outlet {
  margin-top: 0;
}

/* Botones tipo imagen: Volver (outline) + Continuar (filled) */
.form-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}
.form-actions--guardar {
  padding-bottom: 2rem;
}
.btn-step2-volver,
.btn-step2-continuar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  height: 48px;
  border-radius: 100px;
  font-family: 'Poppins-Medium', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  white-space: nowrap;
}
.btn-step2-volver {
  background: #fff;
  color: #000;
  border: 2px solid #000;
}
.btn-step2-volver:hover {
  background: #f5f5f5;
}
.btn-step2-continuar {
  background: #000;
  color: #fff;
  border: none;
}
.btn-step2-continuar:hover:not(:disabled) {
  background: #333;
}
.btn-step2-continuar:disabled {
  background: #9ca3af !important;
  color: #e5e7eb !important;
  cursor: not-allowed;
}
.btn-arrow {
  font-size: 1.1em;
  line-height: 1;
}

.info-collected{
  display: flex;

  .info-collected-item{
    @media (max-width: 768px) {
      width: 100%;
    }
    @media (min-width: 769px) {
      width: 50%;
    }

    .key{
      color: $neutral70;
      font-family: 'Poppins-Regular', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px
    }
    .value{
      color: $neutralBlack;
      font-family: 'Poppins-Medium', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
  }
}

.div-alinear{
  display: flex;
  justify-content: center;
  gap: 40px;
  min-width: 0; /* evita desborde en flex */
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (min-width: 769px) {
    flex-direction: row;
  }
  .item1{
    min-width: 0; /* permite que el flex child no desborde y se respete el ancho */
    @media (max-width: 768px) {
      width: 100%;
    }
    @media (min-width: 769px) {
      width: 100%;
      max-width: 960px;
    }
  }
  .item-img{
    @media (max-width: 768px) {
      width: 100%;
      display: none;
    }
    @media (min-width: 769px) {
      width: 15%;
    }
  }
}

.seccion-separator{
  width: 100%;
  @media (max-width: 768px) {
    margin-top: 32px;
  }
  @media (min-width: 769px) {
    margin-top: 40px;
  }
}

.imagen-pensar{
  @media (min-width: 769px) {
    margin: -10px;
  }
}

.w-accordion-custom{
  @media (max-width: 768px) {
   width: 100%;
  }
  @media (min-width: 769px) {
    width: 352px;
  }
}

.custom-padding{
  @media (max-width: 768px) {
    padding: 0 24px;
  }
  @media (min-width: 769px) {
    padding: 0 76px;
  }
}

.step-4-content {
  padding: 45px 0 56px;
  @include media-breakpoint-down(sm) {
    padding-top: 0;
    padding-bottom: 125px;
  }
  i {
    left: 40%;
    top: 45%;
    &.success {
      color: green;
    }
    &.danger {
      color: red;
    }
  }
  .form-group {
    input[type="text"],
    input[type="email"] {
      border: 1.2px solid #000000;
    }
  }
}

#formsList {
  .disabled {
    & div {
      opacity: 0.5;
      pointer-events: none;
    }
    &:hover {
      cursor: not-allowed;
    }
  }
}
.alert-info {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  background-color: inherit;
  position: sticky;
  width: 100%;
  top: 0;
  right: 0;
  div {
    background: $red-2;
    display: inline-flex;
    align-items: center;

    padding: 8px 25px;
    p {
      @include media-breakpoint-down(sm) {
        font-size: 11px;
      }
    }
  }
  @include media-breakpoint-down(sm) {
    width: calc(100% + 30px);
    position: sticky;
    right: unset;
    top: 65px;
    z-index: 999;
    margin-left: -15px;
    margin-right: -15px;
    justify-content: center;
    padding: 5px 4px;
  }

  img {
    width: 25px;
    @include media-breakpoint-down(sm) {
      width: 22px;
    }
  }

  p {
    color: #fff;
    font-size: 14px;
    @include alternative-light-regular;
    margin: 0 5px;
  }

  span {
    color: #fff;
    font-size: 20px;
    @include alternative-medium-regular;
    @include media-breakpoint-down(sm) {
      font-size: 18px;
    }
  }
}

.step-title {
  @include media-breakpoint-down(sm) {
    margin-top: 20px;
  }
  margin-bottom: 28px;

  h3 {
    font-size: 20px;
    @include alternative-bold;
    line-height: 23px;
    margin-bottom: 0;
  }

  p {
    font-size: 18px;
    line-height: 26px;
    @include alternative-regular;
    margin-bottom: 0;
  }
}

.check-box-text {
  span {
    color: $neutralBlack;
    font-family: 'Poppins-Regular', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  a {
    color: #592466;
    font-family: 'Poppins-Bold', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    text-decoration-line: underline;
  }
}
.list-header {
  .btn-pdv-collapse {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 18px;
    font-family: "ubunturegular", Arial, sans-serif;
    width: 100%;
    border: 1px solid #979797;
    background: transparent;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    span {
      font-size: 16px;
      line-height: 18px;
      color: #000;
      @include alternative-medium-regular;
    }

    width: 100%;

    &:not(.collapsed) img {
      transform: rotate(180deg);
    }
    &:focus {
      outline: none;
    }
  }
  &:hover {
    cursor: pointer;
  }
}
.input-hidden-college {
  position: absolute;
  left: -3000px;
  visibility: hidden;
  z-index: -1000;
}
.btn-pdv-primary {
  width: 100%;
  text-align: center;
  min-width: 220px;
  margin-top: 20px;
  &.disabled {
    background-color: #999999;
  }
}

#programInscription .row.form-group {
  margin-bottom: 1rem;
}

.pdv-submit-button {
  /*.form-group {
    margin-top: 0;
  }*/

  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}

.hidden-form {
  position: absolute;
  visibility: hidden;
}
.btn-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  @include media-breakpoint-down(sm) {
    width: 100%;
    .img-webpay {
      display: none;
    }
  }
}
.img-webpay {
  margin-left: 5px;
  width: 126px;
  height: 35px;
}
@media screen and (min-width:320px) and (max-width:480px){
  .d-flex {
    display: block !important;
  }
}

.flex-col {
  flex-direction: column;
}

.recomendation{
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #69ADF1;
  background: #F0F7FF;
  margin-bottom: 21px;
  padding: 12px 16px;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 15px;
  }

  .img-content{
    width: 141px;
    height: 100%;
    display: flex;
    align-items: flex-end;
    margin-right: 15px;
    @media (max-width: 768px) {
      display: none;
    }
    img{
      width: 100%;
      height: auto;
    }
  }
  .text-content{
    display: flex;
    flex-direction: column;
    flex: 1;
    h5{
      color: #115496;
      font-family: 'Poppins-Medium', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; 
    }
    .item{
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      .bullet-yellow{
        margin-right: 15px;
        width: 5px;
        height: 5px;
        border-radius: 100%;
        background: #115496;
      }


      span{
        color: #115496;
        font-family: 'Poppins-Medium', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
      }
    }
  }
}

.form-group input[type=text]{
  border-radius: 100px !important;
  border: 2px solid $neutral30 !important;
  height: 48px !important;
  padding: 12px 24px !important;
}

.form-group input[type=tel]{
  border-radius: 100px !important;
  border: 2px solid $neutral30 !important;
  height: 48px !important;
  padding: 12px 24px !important;
}

.form-group input[type=email]{
  border-radius: 100px !important;
  border: 2px solid $neutral30 !important;
  height: 48px !important;
  padding: 12px 24px !important;
}

.modal-intensive{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
  display: flex;
  align-items: center;
  height: 100vh;
  background: rgba(134, 133, 133, 0.1);


  .content{    
    position: relative;
    width: 40%;
    border-radius: 24px;
    border: 2px solid $neutralBlack;
    background: $neutralwhite;
    padding: 24px;
    box-shadow: 0 0 12px 3px #00000038;
    min-height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include media-breakpoint-down(sm){
      width: 90%;
    }

    .header{
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .btn-modal{
        font-size: 30px;
        border: none;
        background: transparent;
        color: #fff;
        &:hover{
          cursor: pointer;
        }
      }

    }

    .text-content{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      padding: 0 70px;
  
      h5{
        color: $neutralBlack;
        text-align: center;
        font-family: 'Poppins-Bold', sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
        margin-bottom: 10px;
      }

      p {
        color: $neutral80;
        text-align: center;
        font-family: 'Poppins-Regular', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 0px;
        
        span{
          font-family: 'Poppins-Bold', sans-serif;
          font-weight: 700;
        }
      }
    }
    
  }        
}

.img-modal-loading{
  position: absolute;
  right: 20px;
  bottom: 20px;
  height: 70%;

  @media (max-width: 768px) {
    display: none;
  } 
  
}

</style>

<style lang="scss">

  .select2-selection--single {
    height: 48px !important;
    border-radius: 100px !important;
    border: 2px solid $neutral30 !important;
    padding: 12px 12px !important;
  }

  .select2-selection__arrow {
    height: 48px !important;
    right: 10px !important;
  }

  .select2-selection__rendered  {
    line-height: 24px !important;
    color: #495057 !important;
    font-family: "ubunturegular", Arial, sans-serif;
  }

  .año-egreso{
    @media (max-width: 768px) {
    width:50px;
  } 
  }

</style>
